import { render } from "./Tests.vue?vue&type=template&id=29fd8e0b&scoped=true"
import script from "./Tests.vue?vue&type=script&lang=js"
export * from "./Tests.vue?vue&type=script&lang=js"

import "./Tests.vue?vue&type=style&index=0&id=29fd8e0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fd8e0b"]])

export default __exports__